// Site-level helpers used by the Seo component to emit canonical URLs,
// hreflang alternates, and to decide whether we should ship noindex
// (staging + previews must not be crawled). The check runs synchronously
// on module load so Helmet has the right values before first paint.

const PRODUCTION_HOST = 'akademia.dajanarodriguez.app';

export const PRODUCTION_ORIGIN = `https://${PRODUCTION_HOST}`;

export function getOrigin(): string {
  if (typeof window === 'undefined') return PRODUCTION_ORIGIN;
  return window.location.origin;
}

export function getHost(): string {
  if (typeof window === 'undefined') return PRODUCTION_HOST;
  return window.location.host;
}

// Anything that isn't the canonical production host (preview deploys,
// staging, localhost) must declare noindex. Robots.txt also disallows
// crawling these origins as a defence in depth.
export function isProductionHost(): boolean {
  return getHost() === PRODUCTION_HOST;
}

export function buildCanonical(pathname: string): string {
  const origin = getOrigin();
  return `${origin}${pathname}`;
}

// Return the canonical for a SK/CS pair given the current pathname. We
// rewrite the leading /sk or /cs segment.
export function buildHreflangs(pathname: string): { sk: string; cs: string } {
  const origin = getOrigin();
  const path = pathname.replace(/^\/(sk|cs)(?=\/|$)/, '');
  return {
    sk: `${origin}/sk${path}`,
    cs: `${origin}/cs${path}`,
  };
}
